export default "__VITE_ASSET__C_aXc$bg__"